
<template>
  <div class="body">
    <div>

      <el-descriptions class="margin-top" title="案件基本信息" :column="3" border>
        <template slot="extra">
        </template>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label">
            <!-- -->
            <div>案号</div>
          </template>
          <span v-if="caseInfo.registerCode">
            {{ caseInfo.registerCode }}
          </span>
          <span v-else>
            {{ caseInfo.mediationCode }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 批次号 </template>
          {{ caseInfo.batchId }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 立案案由 </template>
          {{ caseInfo.cause }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 法院名称 </template>
          {{ caseInfo.courtName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 标的 </template>
          {{ caseInfo.underlyingAmount }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 案件状态 </template>
          {{ caseInfo.caseStatus }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 委托时间 </template>
          <span style="">
            {{ caseInfo.entrustmentDate }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 提交服诉讼务网时间 </template>
          {{ caseInfo.subWebDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 提交法院日期 </template>
          {{ caseInfo.courtSubDate }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 立案日期 </template>
          {{ caseInfo.filingDate }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 开庭日期 </template>
          {{ caseInfo.trialDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 审判法官 </template>
          {{ caseInfo.undertakeJudge }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 缴费完成日期 </template>
          {{ caseInfo.payCompletionDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 判决日期 </template>
          {{ caseInfo.decisionDate }}
        </el-descriptions-item>
      
       
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 执行日期 </template>
          {{ caseInfo.executionDate }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 案件完成日期 </template>
          {{ caseInfo.caseCompleDate }}
        </el-descriptions-item>
  
      
        <el-descriptions-item span="1" labelStyle="width:7rem">
          <template slot="label"> 撤诉日期</template>
          {{ caseInfo.dropLawsuitDate }}
        </el-descriptions-item>
        <el-descriptions-item span="1" labelStyle="width:7rem">
          <template slot="label"> 退案日期</template>
          {{ caseInfo.withdrawalDate }}
        </el-descriptions-item>

        <el-descriptions-item span="3" labelStyle="width:7rem">
          <template slot="label"> 短信内容</template>
          {{ caseInfo.paymentMessage }}
        </el-descriptions-item>
     
        <el-descriptions-item span="3" labelStyle="width:7rem">
          <template slot="label"> 异动原因 </template>
          {{ caseInfo.remark }}
        </el-descriptions-item>
        <el-descriptions-item span="3" labelStyle="width:7rem">
          <template slot="label"> 撤诉原因 </template>
          {{ caseInfo.dropLawsuitReason }}
        </el-descriptions-item>


        <el-descriptions-item span="3" labelStyle="width:7rem">
          <template slot="label"> 退案原因 </template>
          {{ caseInfo.withdrawalReason }}
        </el-descriptions-item>
       
      </el-descriptions>
    </div>

    <!-- 当事人信息 -->
    <div v-for="item in caseInfo.partyList" :key="item.id + '原告'">
      <el-descriptions v-if="item.litigationStatus == '原告'" class="margin-top" :title="'原告 ( ' + item.name + ' ) '"
        :column="3" border>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 当事人类型 </template>
          {{ item.partiesType }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 诉讼地位 </template>
          {{ item.litigationStatus }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 名字/公司 </template>
          {{ item.name }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 社会统一信用代码 </template>
          {{ item.idCard }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 法定代表人 </template>
          {{ item.legalRepresentative }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 负责人身份证 </template>
          {{ item.legalRepresentativeIdCard }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 职位 </template>
          {{ item.post }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 手机号码 </template>
          {{ item.phone }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 户籍地/公司所在地 </template>
          {{ item.address }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 送达地址 </template>
          {{ item.serviceAddress }}
        </el-descriptions-item>
        <el-descriptions-item span="1" labelStyle="width:7rem">
          <template slot="label"> 邮箱 </template>
          {{ item.email }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div v-for="item in caseInfo.partyList" :key="item.id + ''">
      <el-descriptions class="margin-top" v-if="item.litigationStatus == '被告'" :title="'被告 ( ' + item.name + ' )'"
        :column="3" border>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 当事人类型 </template>
          {{ item.partiesType }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 诉讼地位 </template>
          {{ item.litigationStatus }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 名字/公司 </template>
          {{ item.name }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 公民身份号码 </template>
          {{ item.idCard }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 性别 </template>
          {{ item.sex }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 出生日期 </template>
          {{ item.birthday }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 民族 </template>
          {{ item.nation }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 手机号码 </template>
          {{ item.phone }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 户籍地 </template>
          {{ item.address }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 送达地址 </template>
          {{ item.serviceAddress }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 约定送达地址 </template>
          {{ item.agreedDeliveryAddress }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 邮箱 </template>
          {{ item.email }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 还款责任 </template>
          {{ item.responsibility }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 被告关系 </template>
          {{ item.defRelationship }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div v-for="item in caseInfo.czCaseAgentList" :key="item.id + '原告代理'">
      <el-descriptions v-if="item.agentPosition == '原告'" class="margin-top" :title="'原告代理人 ( ' + item.agentName + ' )'"
        :column="3" border>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 第一代理人类型 </template>
          {{ item.agentType }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 诉讼代理人名 </template>
          {{ item.agentName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 代理人性别 </template>
          {{ item.sex }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 身份证号 </template>
          {{ item.idCard }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 手机号 </template>
          {{ item.phone }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 地址 </template>
          {{ item.address }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 律师执业证 </template>
          {{ item.lawyerLicenseNo }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 诉讼代理人所在律所名称 </template>
          {{ item.lawfirmName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 庭审是否到场 </template>
          {{ item.isPresent == 0 ? "否" : "是" }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div v-for="item in caseInfo.czCaseAgentList" :key="item.id">
      <el-descriptions v-if="item.agentPosition == '被告'" class="margin-top" :title="'被告代理人 ( ' + item.agentName + ' )'"
        :column="3" border>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 第一代理人类型 </template>
          {{ item.agentType }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 诉讼代理人名 </template>
          {{ item.agentName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 身份证号 </template>
          {{ item.idCard }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 手机号 </template>
          {{ item.phone }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 地址 </template>
          {{ item.address }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 律师执业证 </template>
          {{ item.lawyerLicenseNo }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 诉讼代理人所在律所名称 </template>
          {{ item.lawfirmName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 庭审是否到场 </template>
          {{ item.isPresent }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <!-- 信用卡信息 -->
    <div v-for="item in caseInfo.cardInfoList" :key="item.id">
      <el-descriptions class="margin-top" :title="'信用卡 ( ' + item.cardNumber + ' )'" :column="3" border>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 账号 </template>
          {{ item.accountNumber }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 签署协议名称 </template>
          {{ item.signingName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 信用卡号 </template>
          {{ item.cardNumber }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 产品名称 </template>
          {{ item.productName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 申请日期 </template>
          {{ item.applicationDate }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 核销日期 </template>
          {{ item.accountDestroyDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 核销截止日期 </template>
          {{ item.accountDestroyEndDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 本金 </template>
          {{ item.principal }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 欠款总额 </template>
          {{ item.totalDebt }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 利息 </template>
          {{ item.interest }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 利息截止日期 </template>
          {{ item.deadlineDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 分期手续费 </template>
          {{ item.serviceCharge }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 分期手续费截止日期 </template>
          {{ item.serviceChargeEndDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 违约金 </template>
          {{ item.liquidatedDamages }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 违约金截止日期 </template>
          {{ item.liqDamagesEndDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 分期通手续费 </template>
          {{ item.serviceChargeTwo }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 分期通手续费截止日期 </template>
          {{ item.serviceChargeTwoEndDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 其他费用 </template>
          {{ item.otherExpenses }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 其他费用说明 </template>
          {{ item.otherDescription }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 其他费用截止日期 </template>
          {{ item.otherDescriptionEndDate }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 其他费用2 </template>
          {{ item.otherExpenses2 }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 其他费用2说明 </template>
          {{ item.otherDescription2 }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 其他费用2截止日期 </template>
          {{ item.otherDescription2EndDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 逾期日期 </template>
          {{ item.overdueDate }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
     
    <div v-if="caseInfo.liveCaseElement != undefined">
      <!--v-if="caseInfo.czInstallment.length != 0" -->
      <el-descriptions class="margin-top" title="要素信息" :column="3" border>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 签订合同名称 </template>
          {{ caseInfo.liveCaseElement.contractName }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 违约条款 </template>
          {{ caseInfo.liveCaseElement.clause }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 合同签订日期 </template>
          {{ caseInfo.liveCaseElement.contractDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 违约时间 </template>
          {{ caseInfo.liveCaseElement.liquidatedDate }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 签订年限 </template>
          {{ caseInfo.liveCaseElement.contractYear }}
        </el-descriptions-item>
        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 合同违约金 </template>
          {{ caseInfo.liveCaseElement.contractLiquidatedDamages }}
        </el-descriptions-item>

        <el-descriptions-item labelStyle="width:7rem">
          <template slot="label"> 起诉违约金 </template>
          {{ caseInfo.liveCaseElement.liquidatedDamages }}
        </el-descriptions-item>
      
      </el-descriptions>
    </div>
  </div>
</template>
  
<script>
import {
   getLiveCaseInfo
} from "@/api/czManager/liveCaseInfo/index";

export default {
  components: {},
  props: ["id", "data"],
  data() {
    return {
      caseInfo: {
      },
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
      getLiveCaseInfo(this.id).then(res => {
        this.caseInfo = res
            //  this.caseInfo = ResizeObserver
      })
  },
  mounted() { },
};
</script>
<style scoped>
.margin-top {
  margin-top: 20px;
}

.body>>>.el-descriptions-item__content {
  width: 8rem !important;
  /* background-color: red; */
}
</style>